import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import {
  orderNumberFromModel,
  validateOrderNumberCondition,
  type OrderNumberState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_NUMBER = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderNumberState>>,
): ConditionType<OrderNumberState, ModelCondition.OrderNumber> => ({
  name: "Order number",
  description(state) {
    return `Order numbers: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<OrderNumberState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return orderNumberFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.ORDER_NUMBER, orderNumbers: state };
  },
  valid(state) {
    return validateOrderNumberCondition(state).valid;
  },
});

export { type OrderNumberState } from "@redotech/redo-model/return-flow/condition-validate";
